import React from "react";
import { Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import { BRAND_NAME } from "Constant/constants";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  appendDots: (dots) => (
    <div>
      <ul className="flex justify-center gap-2 mt-4 list-unstyled">{dots}</ul>
    </div>
  ),
  customPaging: () => (
    <div className="w-2 h-2 bg-primary-300 rounded-full transition-all duration-300" />
  ),
};

const AuthLayout = ({ children }) => {
  return (
    <div className="d-flex justify-content-center align-items-center p-5 h-screen">
      <Row className="h-100 w-100 g-0">
        <Col xl={5} lg={6} md={12} sm={12} xs={12}>
          <div className="p-xl-10 p-5 text-white rounded-2xl bg-primary-950 h-100 d-lg-flex flex-column position-relative">
            <div className="position-absolute top-0 start-0 bottom-0 end-0 rounded-2xl overflow-hidden">
              <img
                src="/assets/images/log-reg-bg.jpg"
                alt=""
                className="w-100 h-100 object-fit-cover"
              />
            </div>
            <div className="position-relative z-1 h-100 d-lg-flex flex-column gap-4 text-center">
              <div className="max-w-400 mx-auto h-100 d-flex flex-column text-center">
                <div className="nav_logo d-flex justify-content-center align-items-center mb-4">
                  <img
                    src="/assets/images/PlutoEdu-Monochrome.svg"
                    alt=""
                    width={190}
                  />
                </div>
                <h1 className="mb-4 text-xl-4xl text-lg-3xl text-xl leading-normal font-bold">
                  Welcome to {BRAND_NAME}
                </h1>
                <h2 className="text-base text-lg-md font-normal leading-normal">
                  One Platform. Endless Possibilities.
                </h2>

                <div className="mt-auto">
                  <div className="w-full max-w-3xl mx-auto py-10 morphing-dots-slider">
                    <Slider {...settings}>
                      {Array.from({ length: 3 }).map((_, idx) => (
                        <div key={idx}>
                          <h3 className="text-lg text-lg-2xl font-semibold leading-normal">
                            Built for Collaboration
                          </h3>
                          <p className="text-base text-lg-lg leading-normal">
                            Connect with the right people for your career,
                            wherever you are.
                          </p>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col
          xl={7}
          lg={6}
          md={12}
          sm={12}
          xs={12}
          className="h-lg-100 overflow-auto d-flex flex-column justify-content-center py-5"
        >
          {children}
        </Col>
      </Row>
    </div>
  );
};

export default AuthLayout;
